module.exports = __webpack_public_path__ + "img/review2.cccc290e.png";